import * as React from "react";
import { Alert, Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { DetailsTabPanel } from "../../../../components/common/detailTabPanel/detailTabPanel";
import { useAreaPreference } from "../../../../hooks/useAreaPreference";
import SessionPayrollPanel from "./sessionPayroll";
import { useGetPayrollBySessionIdQuery } from "../../../../services/cclTokenedPayrollApi";
import ComponentLoader from "../../../../components/common/componentLoader";
import { SessionDetailType } from "../../../../services/types/sessionDetailTypes";

interface SessionPayrollPanelProps {
    sessionId: string;
    sessionName: string;
    session: SessionDetailType | undefined;
}

const SessionPayrollTabPanel: React.FC<SessionPayrollPanelProps> = (props) => {
    const [activeTab, setActiveTab] = useAreaPreference<number>("sessionDetail", "payroll.subTab", 0);
    const [projectId, setProjectId] = React.useState<string>("");
    const [projectName, setProjectName] = React.useState<string>(props.sessionName);

    const { data: payrollData, isLoading: payrollLoading, refetch } = useGetPayrollBySessionIdQuery(props.session?.sessionCode || "");

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number | null) => {
        if (newValue != null) setActiveTab(newValue);
    };

    const sendToReport = () => {
        setActiveTab(1);
    }
    console.log(props.session?.sessionCode)
    React.useEffect(() => {
        setProjectName(props.sessionName);
        if (payrollData && payrollData.projectId) {
            setProjectId(payrollData.projectId);
            setProjectName(payrollData.projectName);
        }
    }, [payrollData]);

    let tablist: [string, number, React.ReactNode][] = [
        [
            "Session Payroll",
            0,
            <SessionPayrollPanel 
                payroll={payrollData} 
                projectId={projectId}
                projectCode={props.session?.sessionCode ?? ""}
                projectName={projectName}
                sendToReport={sendToReport} 
                sessionId={props.sessionId}
                refetchPayroll={refetch}
                session={props.session ? props.session : {} as SessionDetailType}
            />,
        ],
    ];

    if (props.sessionId === undefined) {
        return (
            <Box>
                <Alert severity="error">Error: Session data not found!</Alert>
            </Box>
        );
    }

    if (payrollLoading) {
        return <ComponentLoader msg={"Loading"} />;
    }

    return (
        <>
            <Box
                sx={{
                    width: 1,
                    height: 1,
                    m: 2,
                    marginTop: 2,
                    borderWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    sx={{ borderWidth: 0, flexGrow: 1 }}
                >
                    {tablist.length > 1 ? (
                        <ToggleButtonGroup
                            color="primary"
                            value={activeTab}
                            exclusive
                            onChange={handleTabChange}
                            sx={{ mb: 3 }}
                        >
                            {tablist.map((tab, i) => (
                                <ToggleButton
                                    key={i}
                                    id={`session-details-payroll-tab-${i}`}
                                    value={i}
                                >
                                    {tab[0]}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    ) : null}
                </Box>
                {tablist.map((tab, i) => (
                    <DetailsTabPanel
                        detailType={"session-details-payroll"}
                        key={tab[0]}
                        value={activeTab}
                        index={i}
                    >
                        {tab[2]}
                    </DetailsTabPanel>
                ))}
            </Box>
        </>
    );
};

export default SessionPayrollTabPanel;
